<template>
  <div class="mb-8">
    <div v-for="(faq, index) in defaultShowItems" :key="index" class="faq mb-2">
      <FaqAccordion :faq="faq" />
      <div v-if="index !== defaultShowItems.length - 1" class="border-b border-b-[#d9d9d9]" />
    </div>
    <div v-if="hiddenItemCount > 0" class="mr-3 flex flex-row-reverse">
      <button v-if="shouldShowViewMoreButton" class="text-gold1 underline" @click="show">view more</button>
      <button v-if="shouldShowViewLessButton" class="text-gold1 underline" @click="hide">view less</button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useExpandableList } from '@/composables/ui/useExpandableList';
import FaqAccordion from '@/wabunka-src/features/FAQ/components/FaqAccordion/FaqAccordion.vue';
import type { EnFaqListViewModel } from '@/wabunka-src/features/FAQ/models/enFaq';

interface Props {
  categorizedFaqs: EnFaqListViewModel;
  defaultShowCount?: number;
}
const props = defineProps<Props>();

const { isAllShown, show, hide } = useExpandableList();

const defaultShowItems = computed(() => {
  return isAllShown.value ? props.categorizedFaqs : props.categorizedFaqs.slice(0, props.defaultShowCount);
});

const hiddenItemCount = computed(() => {
  if (props.defaultShowCount && props.categorizedFaqs.length > props.defaultShowCount) {
    return props.categorizedFaqs.length - props.defaultShowCount;
  }
  return 0;
});

const shouldShowViewMoreButton = computed(() => {
  return hiddenItemCount.value && !isAllShown.value;
});

const shouldShowViewLessButton = computed(() => {
  return hiddenItemCount.value && isAllShown.value;
});
</script>
